// extracted by mini-css-extract-plugin
export default {"wrap":"PageLoading_wrap__cSjtE","spinner":"PageLoading_spinner__Bqysn","spin":"PageLoading_spin__p0WIJ","text":"PageLoading_text__wwJxS"};